import React, { useContext, useEffect } from "react";
import { FaArrowLeft } from "react-icons/fa";
import { useNavigate } from "react-router-dom";
import NavigateButton from "../../../../components/buttonsNavigate";
import hocStarredPage from "../../../../components/hocStarredPage";

const ChangeStatusPagev2 = () => {
  const history = useNavigate();
  const permissions = JSON.parse(localStorage.getItem("permissions"));

  return (
    <>
      <div className=" h-full bg-white">
        <div className=" mb-5 sticky top-0 flex flex-col bg-white">
          {/* header */}
          <div className="w-full bg-dbase h-16">
            <div className="container flex relative gap-7 flex-row justify-start w-full text-white h-full my-auto">
              <button onClick={() => history(-1)}>
                <FaArrowLeft />
              </button>
              <h2 className="text-xl my-auto">Change Status</h2>
            </div>
          </div>
        </div>

        <div className="  grid grid-cols-2 container gap-x-6 gap-y-4">
          {(window.location.host.startsWith("localhost") || window.location.host === "pda.ishtari.com") && (
            <>
              {permissions.pda_order_change_status_given && (
                <NavigateButton
                  name={"GIVEN"}
                  color={"bg-[rgb(7,89,133)]"}
                  onclick={() => history("given")}
                />
              )}
              {permissions.pda_order_change_status_received_from_seller && (
                <NavigateButton
                  name={"RECEIVED FROM SELLER"}
                  color={"bg-[rgb(147,51,234)]"}
                  onclick={() => history("receivedfromseller")}
                />
              )}
              {permissions.pda_order_change_status_given_to_seller && (
                <NavigateButton
                  name={"GIVEN TO SELLER"}
                  color={"bg-[rgb(107,114,128)]"}
                  onclick={() => history("giventoseller")}
                />
              )}

              {/* {permissions.pda_order_change_status_failed && (
                <NavigateButton
                  name={"Prepare Awaiting Failed"}
                  color={"bg-[#bf1b26]"}
                  onclick={() => history("failed")}
                />
              )} */}

            </>
          )}

          {(window.location.host === "pda.ishtari.com.gh" || window.location.host === "pda.energyplus-lb.com") && (
            <>
              <NavigateButton
                name={"GIVEN"}
                color={"bg-[rgb(7,89,133)]"}
                onclick={() => history("given")}
              />
              <NavigateButton
                name={"RECEIVED FROM SELLER"}
                color={"bg-[rgb(147,51,234)]"}
                onclick={() => history("receivedfromseller")}
              />
              <NavigateButton
                name={"GIVEN TO SELLER"}
                color={"bg-[rgb(107,114,128)]"}
                onclick={() => history("giventoseller")}
              />
              <NavigateButton
                name={"PREPARE AWAITING FAILED"}
                color={"bg-[#bf1b26]"}
                onclick={() => history("failed")}
              />
              <NavigateButton
                name={"HOLD GIVEN"}
                color={"bg-[rgb(0,10,200)]"}
                onclick={() => history("holdgiven")}
              />
              <NavigateButton
                name={"HOLD READY"}
                color={"bg-[rgb(200,0,0)]"}
                onclick={() => history("holdready")}
              />
            </>
          )}

        </div>

      </div>
    </>
  );
};

export default hocStarredPage(ChangeStatusPagev2);
